import * as Constants from '../../constants';

import { useState, useEffect, useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';

import { Link } from 'react-router-dom';

import classes from "./WalletReitsList.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faExternalLink, faPlusCircle, faFileDownload, faFileUpload } from "@fortawesome/free-solid-svg-icons";

import { Button } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';

import AssetForm from '../../components/AssetForm';
import ScrollContainer from '../../components/UI/ScrollContainer';
import ConfirmDialog from '../../components/UI/ConfirmDialog';

import { CSVLink } from "react-csv";
import Papa from 'papaparse';

const dollarQuotationFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 4,
  maximumFractionDigits: 4
});

const brlFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

const usdFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'USD',
  currencyDisplay: 'narrowSymbol'
});

const percentageFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

const defaultFormAsset = { id: 0, ticker: 0, quotas: 0, price: 0 };

function WalletReitsList(props) {
  const csvUploadFileRef = useRef();
  const total = useSelector(state => state.total);
  const dollarCurrent = localStorage.getItem("dollarCurrent");
  const dollar = localStorage.getItem("dollar");

  const [reits, setReits] = useState([]);
  const [allReits, setAllReits] = useState([]);
  const [totalREITs, setTotalREITs] = useState(0);
  const [totalInvestidoReits, settotalInvestidoReits] = useState(0);
  const [rentabilidadeTotal, setRentabilidadeTotal] = useState(0);
  const [formIsShown, setFormIsShown] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [deleteConfirmationIsShown, setDeleteConfirmationIsShown] = useState(false);
  const [deleteWalletConfirmationIsShown, setDeleteWalletConfirmationIsShown] = useState(false);
  const [selectedWalletItem, setSelectedWalletItem] = useState(defaultFormAsset);
  const threshold = localStorage.getItem('threshold');

  const assetSubmitHandler = async () => {
    await fetchREITsHandler();
    hideFormHandler();
  };

  const hideFormHandler = () => {
    setFormIsShown(false);
  };

  const deleteConfirmationHandler = async () => {
    props.setIsLoading(true);
    try {
      const response = await fetch(Constants.DELETE_WALLET_ASSET, {
        method: "DELETE",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ "id": selectedWalletItem.id })
      });

      if (!response.ok) {
        throw new Error('Something went wrong!');
      }
    } catch (error) {
    }
    setSelectedWalletItem({});
    setDeleteConfirmationIsShown(false);
    fetchREITsHandler();
    props.onUpdateAssets(totalInvestidoReits, totalREITs);
    props.setIsLoading(false);
  };

  const hideDeleteConfirmationHandler = () => {
    setDeleteConfirmationIsShown(false);
  };

  const hideDeleteWalletConfirmationHandler = () => {
    setDeleteWalletConfirmationIsShown(false);
  };

  const deleteHandler = (id) => {
    const title = reits.filter((el) => { return el.id === id })[0].ticker;
    setSelectedWalletItem({ id, title });
    setDeleteConfirmationIsShown(true);
  };

  const addHandler = (id) => {
    setSelectedWalletItem(defaultFormAsset);
    setEditMode(false);
    setFormIsShown(true);
  };

  const deleteWalletConfirmationHandler = async () => {
    props.setIsLoading(true);
    try {
      const response = await fetch(Constants.DELETE_WALLET_ASSET, {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ "class": 5 })
      });

      if (!response.ok) {
        throw new Error('Something went wrong!');
      }
    } catch (error) {
      console.warn(error);
    }
    setDeleteWalletConfirmationIsShown(false);
    fetchREITsHandler();
    props.onUpdateAssets(totalInvestidoReits, totalREITs);
    props.setIsLoading(false);
  };

  const deleteWalletHandler = () => {
    setDeleteWalletConfirmationIsShown(true);
  };

  const submitAssetListHandler = async (data) => {
    let pData = [];
    data.forEach(asset => {
      const assetData = {
        id: asset[1],
        quotas: asset[0],
        averagePrice: asset[2]
        // averagePrice: asset[2].replace(",", ".")
      };
      pData.push(assetData);
    });
    const listData = {
      class: 4,
      data: pData
    }

    const id = localStorage.getItem("id");
    const url = `${Constants.ADD_ASSET_LIST}?id=${id}`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(listData)
    });
  };

  const uploadButtonHandler = () => {
    csvUploadFileRef.current.click();
  };

  const csvUploadHandler = (event) => {
    const fileObj = event.target.files && event.target.files[0];
    // console.log(fileObj);

    Papa.parse(fileObj, {
      skipEmptyLines: true,
      complete: function (results) {
        submitAssetListHandler(results.data);
      }
    });

    fetchREITsHandler();
  };

  const editHandler = (id) => {
    const filtered = reits.filter((el) => { return el.id === id })[0];
    const selected = allReits.filter((el) => { return el.title === filtered.ticker })[0];

    setSelectedWalletItem({
      id,
      ticker: selected.title,
      quotas: Number(filtered.cotas),
      price: Number(filtered.price)
    });
    setEditMode(true);
    setFormIsShown(true);
  };

  const fetchAllReitsHandler = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(Constants.WALLET_REITS_LIST, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      if (!response.ok) {
        throw new Error('Something went wrong!');
      }
      const data = await response.json();
      setAllReits(data);
    } catch (error) {
      console.warn(error);
    }
  }, []);

  const fetchREITsHandler = useCallback(async () => {
    props.setIsLoading(true);
    let rentabilidade = 0;
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(Constants.WALLET_REITS_LIST, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      if (!response.ok) {
        throw new Error('Something went wrong!');
      }

      const data = await response.json();
      let sum = 0;
      let sumInvestido = 0;
      const loadedREITs = [];

      for (let item of data) {
        let investido = item.price * item.quantity;
        let atual = item.currentPrice * item.quantity;

        let reit = {
          id: item.id,
          setor: item.sector,
          subsetor: item.subsector,
          ticker: item.title,
          cotas: item.quantity,
          price: item.price,
          currentPrice: item.currentPrice,
          valorInvestido: investido,
          valorAtual: atual,
          rentabilidadePercentual: (atual - investido) / investido,
          rentabilidadeAbsoluta: (atual - investido),
          parcelaTotalGeral: atual
        }

        const indicators = item.indicators;
        for (const [indicator, value] of Object.entries(indicators)) {
          reit[indicator] = value;
        }
        //reit['yoc'] = ((Number(indicators.d.replace(",", ".")) / Number(item.price) * 100).toFixed(2));
        reit['yoc'] = '';
        sum += reit.valorAtual * dollarCurrent;
        sumInvestido += reit.valorInvestido * dollar;
        rentabilidade += reit.rentabilidadeAbsoluta;
        loadedREITs.push(reit);
      }
      setTotalREITs(sum);
      settotalInvestidoReits(sumInvestido);
      setReits(loadedREITs);
      setRentabilidadeTotal(rentabilidade);
      props.onUpdateAssets(sumInvestido, sum);
      props.setIsLoading(false);
    } catch (error) {
      console.warn(error);
    }
    props.setIsLoading(false);
  }, [total, reits]);

  useEffect(() => {
    fetchAllReitsHandler();
    fetchREITsHandler();
  }, []);

  useEffect(() => {
    props.onUpdateAssets(totalInvestidoReits, totalREITs);
    props.setIsLoading(false);
  }, [total, totalREITs, reits]);

  const csvDownloadHandler = () => {
    let acoesCopy = [];
    reits.forEach(object => {
      const obj = {
        cotas: object.cotas,
        codigo: object.codigo,
        price: object.price,
        id: object.id
      }
      acoesCopy.push(obj);
    });
    return acoesCopy;
  }

  const confirmDeleteMessage = <>Tem certeza que deseja excluir o ativo <b>{selectedWalletItem.title}</b>?</>;
  const confirmDeleteWalletMessage = <>Tem certeza que deseja excluir todos os ativos?</>;

  return <>
    {formIsShown && <AssetForm
      edit={editMode}
      active={selectedWalletItem}
      assets={allReits}
      method="POST"
      onFinishSubmit={assetSubmitHandler}
      onClose={hideFormHandler}
    />}
    {deleteConfirmationIsShown && <ConfirmDialog
      variant="warning"
      onConfirm={deleteConfirmationHandler}
      onCancel={hideDeleteConfirmationHandler}
      header="Atenção!"
      message={confirmDeleteMessage}
    />}
    {deleteWalletConfirmationIsShown && <ConfirmDialog
      variant="danger"
      onConfirm={deleteWalletConfirmationHandler}
      onCancel={hideDeleteWalletConfirmationHandler}
      header="Atenção!"
      message={confirmDeleteWalletMessage}
    />}

    {!props.isLoading &&
      <>
        <div className='row'>
          <div className='col col-md-2'>
            <Button onClick={addHandler} variant="primary" type="button" size="sm" className="m-1">
              <FontAwesomeIcon icon={faPlusCircle} />&nbsp;Adicionar
            </Button>

            <Button onClick={uploadButtonHandler} variant="outline-primary" type="button" size="sm" className="m-1" title="Enviar CSV">
              <input
                ref={csvUploadFileRef}
                onChange={csvUploadHandler}
                type="file"
                accept="text/csv"
                style={{ display: "none" }}
              />
              <FontAwesomeIcon icon={faFileUpload} />
            </Button>

            <CSVLink data={csvDownloadHandler()} filename={"reits.csv"}>
              <Button variant="outline-success" type="button" size="sm" className="m-1" title="Baixar CSV">
                <FontAwesomeIcon icon={faFileDownload} />
              </Button>
            </CSVLink>

            <Button onClick={deleteWalletHandler} variant="outline-danger" type="button" size="sm" className="m-1">
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </div>

          <div className='col col-md-2'>
            <span className="fw-bold">Total Geral:</span> {isNaN(total) ? 0 : brlFormatter.format(total)}
          </div>

          <div className='col col-md-3'>
            <span className="fw-bold">Total Investido em REITs:</span><br /><small>{usdFormatter.format(totalInvestidoReits / dollar)} x {dollarQuotationFormatter.format(dollar)} = {brlFormatter.format(totalInvestidoReits)}</small>
          </div>

          <div className='col col-md-3'>
            <span className="fw-bold">Total em REITs:</span> {isNaN(totalREITs) || totalREITs === 0 ? '0%' : percentageFormatter.format(totalREITs / total)}<br /><small>{usdFormatter.format(totalREITs / dollarCurrent)} x {dollarQuotationFormatter.format(dollarCurrent)}  = {brlFormatter.format(totalREITs)}</small>
          </div>

          <div className="col col-md-2">
            <span className={(rentabilidadeTotal >= 0 ? 'fw-bold positive' : 'fw-bold negative')}>Rentabilidade:</span> {isNaN(rentabilidadeTotal) || rentabilidadeTotal === 0 ? '0%' : percentageFormatter.format((totalREITs - totalInvestidoReits) / totalInvestidoReits)} <br /> <small>{brlFormatter.format(totalREITs - totalInvestidoReits)}</small>
          </div>
        </div>

        <ScrollContainer heightMultiplier={0.6337}>
          <Table striped bordered hover>
            <thead className={`fixedTableHead`}>
              <tr>
                <th rowSpan="2" className={classes.th}>Cotas</th>
                <th rowSpan="2" className={classes.th}>Código</th>
                <th rowSpan="2" className={classes.th}>Setor<br />Subsetor</th>
                <th rowSpan="2" className={classes.th}>Margem<br />Líquida</th>
                <th rowSpan="2" className={classes.th}>Payout</th>
                {/* <th rowSpan="2" className={classes.th}>PVP</th> */}
                <th colSpan="3" className={classes.th}>Dividendos</th>
                {/* <th rowSpan="2" className={classes.th}>Dividend<br />Yield</th> */}
                {/* <th rowSpan="2" className={classes.th}>Último<br />Dividendo</th> */}
                <th colSpan="3" className={classes.th}>Variação</th>
                <th colSpan="2" className={classes.th}>Preço</th>
                <th colSpan="2" className={classes.th}>Valor</th>
                <th rowSpan="2" className={classes.th}>%<br />Geral</th>
                <th colSpan="2" className={classes.th}>Rentabilidade</th>
                <th rowSpan="2" className={classes.th}>Operações</th>
              </tr>
              <tr>
                <th className={classes.th}>YOC</th>
                <th colSpan="2" className={classes.th}>12 Meses</th>
                {/* <th className={classes.th}>1 Mês</th> */}
                <th className={classes.th}>1 Dia</th>
                <th className={classes.th}>1 Mês</th>
                {/* <th className={classes.th}>2023</th> */}
                <th className={classes.th}>1 Ano</th>
                <th className={classes.th}>Médio</th>
                <th className={classes.th}>Atual</th>
                <th className={classes.th}>Investido</th>
                <th className={classes.th}>Atual</th>
                <th className={classes.th}>%</th>
                <th className={classes.th}>$</th>
              </tr>
            </thead>
            <tbody>
              {reits.length === 0 && <tr>
                <td colSpan='20'>Nenhum ativo cadastrado.</td>
              </tr>
              }
              {
                reits.map((reit) => <tr key={reit.id}>
                  <td className={classes.td}>{reit.cotas}</td>
                  <td className={classes.td + " text-center"}>
                    <span className="font-weight-bold">{reit.ticker}</span><br />
                    <a href={`${Constants.BASE_URL_EUA_REIT_STATUSINVEST}${reit.ticker}`} target='_blank' rel="noreferrer" title='StatusInvest'>
                      <FontAwesomeIcon icon={faExternalLink} />
                    </a>&nbsp;&nbsp;
                    <a href={`${Constants.BASE_URL_EUA_REIT_YAHOOFINANCE}${reit.ticker}`} target='_blank' rel="noreferrer" title='Yahoo! Finance'>
                      <FontAwesomeIcon icon={faExternalLink} />
                    </a>
                  </td>
                  <td className={classes.td}>{reit.setor}<br />{reit.subsetor}</td>
                  <td className={classes.td}>{percentageFormatter.format(reit.mL / 100)}</td>
                  <td className={classes.td}>{reit.payout}%</td>
                  {/* <td className={classes.td + "" + (reit.pvp < 1 ? " text-success" : "")}>{reit.pvp.replace(".", ",")}</td> */}
                  <td className={classes.td + "" + (reit.yoc < reit.dy ? " text-danger" : "")}>{percentageFormatter.format(reit.yoc / 100)}</td>
                  <td className={classes.td}>{percentageFormatter.format(reit.dy / 100)}</td>
                  <td className={classes.td}>$ {reit.d ? reit.d.replace(".", ",") : ""}</td>
                  <td className={classes.td + "" + (reit.vD < 0 ? " text-danger" : "")}>{percentageFormatter.format(reit.vD / 100)}</td>
                  <td className={classes.td + "" + (reit.vM < 0 ? " text-danger" : "")}>{percentageFormatter.format(reit.vM / 100)}</td>
                  {/* <td className={classes.td}>{reit.vYTD}%</td> */}
                  <td className={classes.td + "" + (reit.vY < 0 ? " text-danger" : "")}>{percentageFormatter.format(reit.vY / 100)}</td>
                  <td className={classes.td + " fw-bold " + classes.emphasis + (reit.price > reit.currentPrice ? " text-danger" : " text-success")}>{usdFormatter.format(reit.price)}</td>
                  <td className={classes.td}>{usdFormatter.format(reit.currentPrice)}</td>
                  <td className={classes.td + (reit.valorInvestido > reit.valorAtual ? " text-danger" : "")}>{usdFormatter.format(reit.valorInvestido)}</td>
                  <td className={classes.td}>{usdFormatter.format(reit.valorAtual)}</td>
                  <td className={classes.td + "" + (reit.parcelaTotalGeral * dollarCurrent * 100 / total > threshold ? " text-danger" : "")}>{percentageFormatter.format(reit.parcelaTotalGeral * dollarCurrent / total)}</td>
                  <td className={classes.td + (reit.rentabilidadePercentual < 0 ? " text-danger" : " text-success")}>{percentageFormatter.format(reit.rentabilidadePercentual)}</td>
                  <td className={classes.td + (reit.rentabilidadeAbsoluta < 0 ? " text-danger" : "")}>{usdFormatter.format(reit.rentabilidadeAbsoluta)}</td>
                  <td className={classes.td} style={{ textAlign: "center" }}>
                    <Link onClick={() => editHandler(reit.id)}><FontAwesomeIcon icon={faEdit} /></Link>&nbsp;&nbsp;&nbsp;
                    <Link onClick={() => deleteHandler(reit.id)}><FontAwesomeIcon icon={faTrash} /></Link>
                  </td>
                </tr>
                )
              }
            </tbody>
          </Table>
        </ScrollContainer>
      </>
    }
  </>
}

export default WalletReitsList;
